import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../core/PageData'
import { TemplateWrapper } from './template-list/TemplateList'
import { useTranslation } from "react-i18next";

const TemplatePage = () => {
  const { t } = useTranslation();
  const usersBreadcrumbs: Array<PageLink> = [
    {
      title: t("Campaign.Title.Template"),
      path: '/template/list',
      isSeparator: false,
      isActive: false,
    }
    ,
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  
  console.log("Templates Page");
  
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <PageTitle breadcrumbs={usersBreadcrumbs}>{t("Campaign.Title.Template")}</PageTitle>
              <TemplateWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/template/list' />} />
    </Routes>
  )
}

export default TemplatePage
